export const renewalRateSummaryHeaders = [
  {
    label: "Company",
    key: "company",
  },
  {
    label: "Customer",
    key: "customer",
  },
  {
    label: "Subscription Plan",
    key: "subscriptionPlan",
  },
    {
    label: "No.of users",
    key: "noOfUsers",
  },
    {
    label: "Days To Expiry",
    key: "daysToExpiry",
  },
    {
    label: "Renewal date",
    key: "renewalDate",
  },
    {
    label: "Status",
    key: "status",
  },
];
